<p class="h2">{{ 'dialogs.reassumableRoleWildcard.title' | translate }}</p>

<div>
	<p>{{ data.message }}</p>
	<p>{{ 'dialogs.reassumableRoleWildcard.description' | translate }}</p>
</div>

<div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
	<button mat-raised-button (click)="cancel()">{{ 'common.cancel' | translate }}</button>
	<button mat-raised-button color="primary" (click)="reassume()">{{ 'dialogs.reassumableRoleWildcard.reassume' | translate }}</button>
</div>
